import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-listformat/polyfill';
import { Box, LinearProgressBar, Text, TextButton } from '@wix/design-system';
import { useFormattedBytes } from '../utils';
import { WithTranslations } from './WithTranslations';
import { LoadingState } from './LoadingState';
import { TooltipContent } from './TooltipContent';
import styles from './MediaStorageWidget.css';
import '@wix/design-system/styles.global.css';
export const MediaStorageWidget = _ref => {
  let {
    isLoading = false,
    locale = 'en',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(WithTranslations, {
    locale: locale
  }, isLoadingTranslations => isLoading || isLoadingTranslations ? /*#__PURE__*/React.createElement(LoadingState, null) : /*#__PURE__*/React.createElement(MediaStorageWidgetInner, _extends({}, props, {
    learnMoreUrl: `https://support.wix.com/${locale}/article/wix-media-managing-your-storage-3724756`
  })));
};
const calculateStorageStatus = (usage, quota) => {
  const usagePercentage = usage / quota * 100;
  let storageStatus;
  if (quota === -1) {
    storageStatus = 'storageStatusUnlimited';
  } else if (usagePercentage >= 100) {
    storageStatus = 'storageStatusFull';
  } else if (usagePercentage >= 95 && usagePercentage < 100) {
    storageStatus = 'storageStatusWarning';
  } else {
    storageStatus = 'storageStatusStandard';
  }
  return {
    storageStatus,
    usagePercentage
  };
};
export const MediaStorageWidgetInner = _ref2 => {
  let {
    usage,
    quota,
    upgradeUrl,
    learnMoreUrl,
    manageStorageUrl,
    dataHook,
    gracePeriodDaysLeft,
    onUpgradeButtonClick,
    onStorageManagerClick,
    onLearnMoreButtonClick
  } = _ref2;
  const remaining = quota - usage;
  const {
    storageStatus,
    usagePercentage
  } = calculateStorageStatus(usage, quota);
  const quotaFormatted = useFormattedBytes(quota);
  const usageFormatted = useFormattedBytes(usage);
  const remainingFormatted = useFormattedBytes(remaining > 0 ? remaining : 0);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    direction: "horizontal",
    width: "100%",
    height: "16px",
    align: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    dataHook: "storage-quota-title"
  }, storageStatus === 'storageStatusUnlimited' ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Storage.Media_Premium_Side_Panel_Label",
    values: {
      current: usageFormatted
    }
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Storage.Media_Side_Panel_Storage_Counter_Label",
    values: {
      current: usageFormatted,
      total: quotaFormatted
    }
  })), /*#__PURE__*/React.createElement(TooltipContent, {
    storageStatus: storageStatus,
    learnMoreUrl: learnMoreUrl,
    onLearnMoreButtonClick: onLearnMoreButtonClick,
    onUpgradeButtonClick: onUpgradeButtonClick,
    remainingStorage: remainingFormatted,
    upgradeUrl: upgradeUrl,
    gracePeriodDaysLeft: gracePeriodDaysLeft
  })), storageStatus !== 'storageStatusUnlimited' && /*#__PURE__*/React.createElement(Box, {
    height: "16px",
    verticalAlign: "middle",
    width: "100%"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.progressBarWrapper
  }, /*#__PURE__*/React.createElement(LinearProgressBar, {
    dataHook: "storage-widget-progress-bar",
    error: storageStatus === 'storageStatusFull',
    skin: storageStatus === 'storageStatusWarning' ? 'warning' : 'standard',
    value: usagePercentage
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    align: "space-between",
    className: styles.manageStorageBox
  }, !!manageStorageUrl && /*#__PURE__*/React.createElement(TextButton, {
    dataHook: "manage-storage-button",
    as: "a",
    skin: "standard",
    weight: "thin",
    size: "tiny",
    href: manageStorageUrl,
    target: "_blank",
    className: styles.manageStorageBtn,
    onClick: onStorageManagerClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Storage.Media_Side_Panel_Manage_Storage_Link"
  })), storageStatus !== 'storageStatusUnlimited' && upgradeUrl && /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    skin: "premium",
    weight: "thin",
    size: "tiny",
    href: upgradeUrl,
    target: "_blank",
    dataHook: "upgrade-button",
    onClick: () => onUpgradeButtonClick == null ? void 0 : onUpgradeButtonClick({
      fromTooltip: false
    })
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Storage.Media_Side_Panel_Upgrade_Link"
  }))));
};
//# sourceMappingURL=MediaStorageWidget.js.map